<template>
  <router-link :to="to" class="generate-panels-button">
    {{ label }}
  </router-link>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'UrlGenerator',
  props: {
    label: {
      type: String,
      default: '',
    },
    layout: {
      type: String,
      default: '',
    },
    markets: {
      type: Array,
      default: () => [],
    },
    audio: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    to() {
      const query = {
        layout: this.layout === 'default' ? '' : this.layout,
        marketIds: this.markets.join(','),
        audio: this.audio,
      };
      return {
        name: 'root',
        query: _.pickBy(query),
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/variables";
@import "~@/assets/scss/buttons";

a {
  text-decoration: none;

  &:hover {
    color: inherit;
  }
}

.generate-panels-button {
  @include button($orange, $orange, $white);
  width: 240px;
  height: 50px;
  padding: 13px 16px;
  display: inline-block;
}
</style>
